/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_Watch_PapersInputs */

const en_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Watch & Papers`)
};

const es_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reloj y Papeles`)
};

const fr_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Montre & Papiers`)
};

const de_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uhr & Papiere`)
};

const ja_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`時計と保証書`)
};

const zh_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`手表 & 保卡`)
};

const ar_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الساعة والأوراق`)
};

const id_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jam & Surat`)
};

const it_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orologio & Documenti`)
};

const ru_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Часы и Документы`)
};

const pt_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relógio e Documentos`)
};

const ko_val_watch_papers = /** @type {(inputs: Val_Watch_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시계 및 보증서`)
};

/**
* | output |
* | --- |
* | "Watch & Papers" |
*
* @param {Val_Watch_PapersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_watch_papers = /** @type {((inputs?: Val_Watch_PapersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_Watch_PapersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_watch_papers(inputs)
	if (locale === "es") return es_val_watch_papers(inputs)
	if (locale === "fr") return fr_val_watch_papers(inputs)
	if (locale === "de") return de_val_watch_papers(inputs)
	if (locale === "ja") return ja_val_watch_papers(inputs)
	if (locale === "zh") return zh_val_watch_papers(inputs)
	if (locale === "ar") return ar_val_watch_papers(inputs)
	if (locale === "id") return id_val_watch_papers(inputs)
	if (locale === "it") return it_val_watch_papers(inputs)
	if (locale === "ru") return ru_val_watch_papers(inputs)
	if (locale === "pt") return pt_val_watch_papers(inputs)
	return ko_val_watch_papers(inputs)
});